<div class="d-flex coverage">
  <div
    class="col-md-4"
    *ngFor="let coverageName of summaryPanel?.CoverageDetails?.CoverageItems"
  >
    <p>{{ coverageName.Name }}</p>
    <div class="row" *ngIf="summaryPanel?.CoverageDetails?.CoverageItems">
      <div
        *ngFor="
          let limits of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
            ?.Limits
        "
      >
        <span>{{ limits.Name }} </span>
        <span class="sub-text">{{ limits.Amount }}</span>
      </div>
    </div>
  </div>

  <div
    class="col-md-4"
    *ngIf="(summaryPanel?.CoverageDetails?.CoverageItems)[0].Deductibles"
  >
    <p class="padlft13">DEDUCTIBLE</p>
    <div class="row">
      <div
        class="col-md-6"
        *ngFor="
          let deductibles of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
            ?.Deductibles
        "
      >
        <span>{{ deductibles.Name }} </span>
        <span class="sub-text">{{ deductibles.Amount }}</span>
      </div>
    </div>
  </div>

  <div
    class="col-md-4"
    *ngIf="(summaryPanel?.CoverageDetails?.CoverageItems)[0].OtherInformation"
  >
    <p class="padlft13">OTHER INFORMATION</p>

    <div class="row">
      <div
        class="col-md-6"
        *ngFor="
          let otherInfo of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
            ?.OtherInformation
        "
      >
        <span>{{ otherInfo.Name }} </span>
        <span class="sub-text">{{ otherInfo.Value }}</span>
      </div>
    </div>
  </div>
</div>
